import { NativeStackHeaderProps } from '@react-navigation/native-stack';
import React from 'react';

export type NoHeaderOwnProps = {};

export type NoHeaderProps = NoHeaderOwnProps & NativeStackHeaderProps;

const NoHeader: React.FC<NoHeaderProps> = () => {
    return null;
};

export default React.memo(NoHeader);
